import React from 'react';
import LoadMoreBtn from './load_more_btn/LoadMoreBtn';
import ReviewItem from './review_item/ReviewItem';
import './reviews-list.scss';

class ReviewsList extends React.Component {

    static genKey(index, raterUsername) {
        return `${index}-${raterUsername}`;
    }

    render() {
        const {
            stars,
            type,
            fetchReviews,
            lastStar,
            showLoadMore,
            gigId,
            pathFinderConfig
        } = this.props;

        // no reviews
        if (!stars || stars.size === 0) {
            return null;
        }

        return (
            <div>
                <ul className="review-list">
                    {stars.map((review, index) =>
                        <ReviewItem key={ReviewsList.genKey(index, review.get('rater_username'))} review={review} gigId={gigId}/>
                    )}
                </ul>
                {showLoadMore && <LoadMoreBtn fetchReviews={fetchReviews}
                    type={type}
                    lastStar={lastStar}
                    pathFinderConfig={pathFinderConfig}/>}
            </div>
        );
    }
}

export default ReviewsList;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/ReviewsList.js